import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import Link from '~/components/Link';
import Form from '~/components/Form';
import * as S from '~/components/Form/styles';
import Input from '~/components/Form/Input';
import routesPath from '~/constants/routes';
import FormConfig from '~/pages/PasswordRecovery/components/FormConfig';
import DefaultLayout from '~/pages/_layouts/DefaultLayout';
import Captcha from '~/components/Form/Captcha';
import { languageOptions } from '~/utils/languageOptions';
import FoldedMenu from '~/components/FoldedMenu';

export default function PasswordRecovery() {
  const { t } = useTranslation();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [captchaValue, setCaptchaValue] = useState(null);
  const [captchaError, setCaptchaError] = useState('');
  const { loading } = useSelector(state => state.auth);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      return;
    }

    const token = await executeRecaptcha('passwordRecovery');
    setCaptchaValue(token);
  }, [executeRecaptcha]);

  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  return (
    <DefaultLayout>
      <FormConfig captchaValue={captchaValue} setCaptchaError={setCaptchaError}>
        {props => {
          // eslint-disable-next-line react/prop-types
          const { isSubmitting, handleSubmit } = props;
          return (
            <S.FormContainer width={30}>
              <Form
                hasWidth={100}
                onSubmit={handleSubmit}
                hasHeight="100vh"
                position="flex-start"
                flex
              >
                <S.Logo />
                <S.FormTitle>{t('passwordRecovery')}</S.FormTitle>
                <Input
                  icon="mail"
                  type="email"
                  selector="email"
                  label={t('email')}
                  placeholder={t('email')}
                  formikProps={props}
                  disabled={loading}
                />
                <Captcha
                  onVerify={setCaptchaValue}
                  captchaError={captchaError}
                />
                <S.SubmitButton
                  type="submit"
                  onClick={() => handleReCaptchaVerify()}
                  disabled={isSubmitting || loading}
                >
                  {isSubmitting || loading
                    ? `${t('loading')}...`
                    : t('sendEmail')}
                </S.SubmitButton>
                <S.Return>
                  <Link to={routesPath.dashboard}>{t('cancel')}</Link>
                </S.Return>
              </Form>
            </S.FormContainer>
          );
        }}
      </FormConfig>
      <FoldedMenu label={t('languageId')} options={languageOptions()} />
    </DefaultLayout>
  );
}
